import React, { useState, useEffect, useRef } from "react";
import "./Layout.css";
import logo from "../../assets/flapone_logo_v4.png";
import mobile from "../../assets/mobile.png";
import {
  MdArrowUpward,
  MdGroup,
  MdLogout,
  MdOutlinePrivacyTip,
  MdLibraryBooks,
} from "react-icons/md";
import { BiUser } from "react-icons/bi";
import { NavLink, Route, Routes } from "react-router-dom";
import { RxReader } from "react-icons/rx";
import profileImage from "../../assets/user.png";
// import payment from "../../assets/payment.jpeg";
// import classImage from "../../assets/className.jpg";
import Money from "../../assets/money.png";
import { MdHelp, MdOutlineRateReview } from "react-icons/md";
import { FaBell, FaCalendarAlt, FaBook, FaUser } from "react-icons/fa";
import MyAccount from "../MyAccount/MyAccount";
import { IoMdMenu } from "react-icons/io";
import Calendar from "../Calendar/Calendar";
import { IoIosPeople, IoIosSettings, IoIosCall } from "react-icons/io";
import Students from "../MyStudent/Students";
import Review from "../MyReviews/Review";
import ContactModal from "../../components/ContactModal";
import { RiArrowDropDownLine, RiBillFill } from "react-icons/ri";
import { IoDocumentText, IoMail } from "react-icons/io5";
import Popup from "../../components/Popup/Popup";
import SingleDropdown from "../../components/SingleDropdown";
import AlertPopup from "../../components/Popup/AlertPoup";
import help from "../../assets/support.svg";
import { logout } from "../../store/authSlice.js";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MyStudent from "../MyStudent/MyStudent.js";
import constant from "../../constant/constant.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GrCatalog } from "react-icons/gr";
import MainLogs from "../Logs/MainLog.js";
import { useLocation } from "react-router-dom";



import axios from "axios";
const ScrollToTopButton = ({ show }) => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`scroll-to-top df fdc ${show ? "show" : ""}`}
      onClick={handleScrollToTop}
    >
      <MdArrowUpward />
    </div>
  );
};

const Layout = () => {
  const user = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [notificationCount, setNotificationCount] = useState(1);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isSubDropdownOpen, setIsSubDropdownOpen] = useState(false);
  const [isContactPopupOpen, setIsContactPopupOpen] = useState(false);
  const [isAccountDropdownOpen, setIsAccountDropdownOpen] = useState(true);
  const [isCalendarDropdownOpen, setIsCalendarDropdownOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState({});

  const [freeDetailsRM, setFreeDetailsRM] = useState(false);
  const [reminderPopup, setReminderPopup] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [contactRMData, setContactRMData] = useState({
    issueType: {},
    comment: "",
  });

  const [rmDetailData,setRmDetailData]=useState({});
  const issueOptions = [
    {
      value: "Facility-Related Issues",
      label: "Facility-Related Issues",
      description:
        "Please describe any concerns with classroom facilities, equipment, or cleanliness",
    },
    {
      value: "Technical Issues",
      label: "Technical Issues",
      description:
        "Please detail any software, device, or connectivity problems you're experiencing",
    },
    {
      value: "Academic Concerns",
      label: "Academic Concerns",
      description:
        "Please specify any issues with course materials, assignments, or exams",
    },
    {
      value: "Support Services",
      label: "Support Services",
      description:
        "Please indicate if you need assistance with counseling, career advice, or other services",
    },
    {
      value: "Communication Problems",
      label: "Communication Problems",
      description:
        "Please report any issues with receiving information or communicating with staff",
    },
    {
      value: "Administrative Issues",
      label: "Administrative Issues",
      description:
        "Please describe any problems with enrollment, registration, or other administrative processes",
    },
    {
      value: "Payment or Billing Problems",
      label: "Payment or Billing Problems",
      description: "Please detail any payment or billing issues you are facing",
    },
    {
      value: "Safety and Security Issues",
      label: "Safety and Security Issues",
      description:
        "Please report any safety concerns or security issues you have noticed",
    },
    {
      value: "Accessibility Issues",
      label: "Accessibility Issues",
      description:
        "Please describe any accessibility barriers you are encountering",
    },
    {
      value: "Other",
      label: "Other",
      description:
        "Please describe any other issues not covered by the above categories",
    },
  ];

  const profileRef = useRef(null);
  const notificationRef = useRef(null);
  const detailsRef = useRef(null);
  const pageRoleAccess = user.user_type;
  const pageOtherDataAccess = user.otherdata.stage;
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const toggleSubDropdown = () => {
    setIsSubDropdownOpen(!isSubDropdownOpen);
  };

  const handleScroll = () => {
    const scrollY = window.scrollY;
    setShowScrollToTop(scrollY > 400);
  };
  const handleLogout = () => {
    // Dispatch the logout action to clear user data
    dispatch(logout());
    // Redirect to the login page
    navigate("/login");
  };


  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {

    const prefix = "Student CRM Portal";
    let pageTitle = document.title;

    const meta = document.querySelector("meta[name='description']");

    if (pageTitle.includes("React App")) {

      const newTitle = "Flapone Student Portal | Drone Training Dashboard";

      document.title = newTitle;

      const description =
        "Flapone student portal to view your aviation and drone training details, course materials, schedules, and certification updates.";

      if (meta) {
        meta.setAttribute("content", description);
      }

    } else {

      const description = `${prefix} - ${pageTitle}`;

      if (meta) {
        meta.setAttribute("content", description.replace(/"/g, ""));
      }

    }

  }, [location]);

  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
    if (
      notificationRef.current &&
      !notificationRef.current.contains(event.target)
    ) {
      setShowNotification(false);
    }
    if (detailsRef.current && !detailsRef.current.contains(event.target)) {
      setFreeDetailsRM(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const closeContactRMPopup = () => {
    setIsContactPopupOpen(false);
    setContactRMData({
      issueType: {},
      comment: "",
    });

  };

  const closeReminderPopup = () => {
    setReminderPopup(false);
  };
  const handleContactRM = () => {
    setIsContactPopupOpen(true);
  };
  const handleChange = (e) => {
    const { id, value } = e.target;
    setContactRMData((prevData) => ({ ...prevData, [id]: value }));
  };
   const handleSubmitRMContact =()=>{
    let newError = {};
    if(Object.keys(contactRMData.issueType).length==0){
      newError.issueType="Please select";
    }
    if(contactRMData.comment.trim()===""){
      newError.comment="Please describe issue";
    }
    setErrorMsg(newError);
    if(Object.keys(newError).length>0){
      return false;
    }
    callSupportRM(contactRMData);
    setContactRMData({
      issueType: {},
      comment: "",
    });
    setIsContactPopupOpen(false);
  }

  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };

const callSupportRM = (contactRMData) =>{
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_header.php?fun=callrmsupport`,
      headers: { "Auth-Id": user.auth_id },
      data: {supportdata: contactRMData},
    })
      .then(function (response) {
        checkUserLogin(response);
        if(response.data.data.status==="0"){
          
        }else{
          toast.success(response.data.data.msg);
          if(response.data.data.rmdata){
            setRmDetailData(response.data.data.rmdata);
          }

        }
      })
      .catch(function (error) {
       console.error("Error during login:", error);
    });
  }

  const handleClickContact = () => {
    if (user.otherdata.stage === "free" || user.otherdata.stage ==="" || user.otherdata.stage === null) {
      setFreeDetailsRM(!freeDetailsRM);
      callSupportRM(contactRMData);
    } else if (user.otherdata.stage === "paid") {
      handleContactRM();
    }
  };
  const handleClickNotification = () => {
    setShowNotification(!showNotification);
  };
  const toggleAccountDropdown = () => {
    setIsAccountDropdownOpen(!isAccountDropdownOpen);
    if (isCalendarDropdownOpen) {
      setIsCalendarDropdownOpen(false);
    }
  };


  return (
    <>
      <header className="appbar df ">
        <div className="left-appbar v-center">
          <div
            className="hamburger-icon"
            onClick={() => setShowSidebar(!showSidebar)}
          >
            <IoMdMenu className="fc6 fs24 cp" />
          </div>

          <div className="mobile-logo dn">
            <img src={mobile} alt="Logo" className="h-logo" />
          </div>
          <div className="header-logo">
            <img src={logo} alt="Logo" className="h-logo" />
          </div>
        </div>
        <div className="appbar-actions">
          <ul className="v-center">
	  {/*
            <li
              className="bell-icon df pr fc6 fs20 cp ml8 "
              onClick={handleClickNotification}
            >
              <FaBell />
              {notificationCount > 0 && (
                <span className="notification-count pa br50 fc1 fw6">
                  {notificationCount}
                </span>
              )}
            </li>
	    */}
            <li className="fc6 fs20 cp ml12" onClick={handleClickContact}>
              <img src={help} alt="Help" className="help" />
            </li>
          </ul>
          {showNotification && (
            <div
              ref={notificationRef}
              className="dropdown-free notification-count-dropdown slide-up"
            >
              <p className="topnav-dropdown-header fc2 fs16 fw6 ls2 lh18">
                Notifications
              </p>
              <ul className="df fdc ais ls1 notification-list">
                <li className="fs14 fc6 ls1 v-center pl8 pr8 pt16 pb16 lh18">
                  <a href="tel:+918048734634" className="df ais">
                    <span className="avatar flex-shrink-0">
                      <img src={profileImage} alt="Profile" />
                      <span className="badge badge-info rounded-pill"></span>
                    </span>
                    <div className="media-body">
                      <p className="noti-details fs14 lh22">
                        Ray Arnold left 6 comments on Isla Nublar SOC2
                        compliance report
                      </p>
                      <p className="noti-sub-details lh22 fs14">
                        “Oh, I finished de-bugging the phones, but the system's
                        compiling for eighteen minutes, or twenty. So, some
                        minor systems may go on and off for a while.”
                      </p>
                      <p className="noti-time fc3">25 Jul 2024 9:42 am</p>
                    </div>
                  </a>
                </li>
                <li className="fs14 fc6 ls1 v-center pl8 pr8 pt16 pb16">
                  <a href="tel:+918048734634" className="df ais">
                    <span className="avatar flex-shrink-0">
                      <img src={profileImage} alt="Profile" />
                      <span className="badge badge-info rounded-pill"></span>
                    </span>
                    <div className="media-body flex-grow-1">
                      <p className="noti-details fs14 lh22">
                        Ray Arnold left 6 comments on Isla Nublar SOC2
                        compliance report
                      </p>

                      <p className="noti-time fc3">25 Jul 2024 9:42 am</p>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          )}

          {freeDetailsRM && (
            <div ref={detailsRef} className="dropdown-free">
              <ul className="df fdc ais ls1">
                <li className="fs14 df fdc pt8 pb8 pl12 pr12">
                  <span className="rm fc2 fs2 fw6 ls1">
                    Relationship Manager
                  </span>
                  <span className="rm fc6 mt4 fs14">{rmDetailData.name}</span>
                </li>

                {rmDetailData.mobile_number	 && (
                  <li className="fs14 mt4 fc6 ls1 pt8 pb8 v-center p8 w100">
                    <a href={`tel:${rmDetailData.country_code}${rmDetailData.mobile_number}`} className="df v-center">
                      <IoIosCall className="fs16 mr4" />
                      {rmDetailData.country_code && (
                        <>
                          {rmDetailData.country_code}-
                        </>
                      )}
                      {rmDetailData.mobile_number}
                    </a>
                  </li>
                )}

                <li className="fs14 mt4 fc6 ls1 pt8 pb8 v-center p8 w100">
                  <a href="mailto:info@flapone.com" className="df v-center">
                    <IoMail className="fs16 mr4" />
                    {rmDetailData.email_id}
                  </a>
                </li>
              </ul>
            </div>
          )}
          <div
            className="profile box-center ml12"
            ref={profileRef}
            onClick={toggleDropdown}
          >
            <img src={user.user_image?user.user_image:profileImage} alt="profile" />
            <div className={`dropdown-menu ${isDropdownOpen ? "open" : ""}`}>
              <div className="profie-name-email">
                <ul className="df fdc ais">
                  <li className="fs14 ls1 lh18 fw6">{user.user_name &&  user.user_name}</li>
                  <li className="fs14 mt4 fc6 ls1">{user.email}</li>
                </ul>
              </div>
              <ul className="profile-list-items">
                <NavLink to="/my-account?tab=settings">
                  <li className="v-center">
                    <BiUser className="fs20 mr24 fc6" />
                    My Account
                  </li>
                </NavLink>
                {pageRoleAccess === "company" && pageOtherDataAccess != "free" ?
                  <NavLink to="/students">
                    <li className="v-center">
                      <MdGroup className="fs20 mr24 fc6" />
                      My Teams
                    </li>
                  </NavLink>
                : ''}

	       {user.access_by_login<=0 &&
                <NavLink to="/my-account?tab=Settings&section=newpass">
                  <li className="v-center">
                    <RxReader className="fs20 mr24 fc6" />
                    Change Password
                  </li>
                </NavLink>
	       }
	     <NavLink to="/calendar">
                  <li className="v-center">
                    <MdOutlinePrivacyTip className="fs20 mr24 fc6" />
                    Calendar
                  </li>
                </NavLink>
		
              </ul>
              <ul className="mt4">
                <NavLink to="">
                  <li className="v-center" onClick={handleLogout}>
                    <MdLogout className="fs20 mr24 fc6" />
                    Logout
                  </li>
                </NavLink>
              </ul>
            </div>
          </div>
          <div
            className="fc6 fs14 ml8 profile-name cp"
            onClick={toggleDropdown}
          >
            <p className="ls1">{user.user_name && user.user_name.length > 10 ? user.user_name.slice(0,10)+"..":user.user_name}</p>
            <p className="mt4 fs12 v-center fw5 ls2">
              Active<span className="login-status"></span>
            </p>
          </div>
        </div>
        {showSidebar && (
          <div className="overlay" onClick={() => setShowSidebar(false)}></div>
        )}
      </header>
      <div className="layout df ">
        <div
          className={`sidebar ${expanded ? "expanded" : ""} ${
            showSidebar ? "show expanded" : "hide"
          }`}
          onMouseEnter={() => setExpanded(true)}
          onMouseLeave={() => setExpanded(false)}
        >
          <NavLink to="/my-account">
            <div
              className="sidebar-conatiner v-center"
              onClick={toggleAccountDropdown}
            >
              <div className="icon-side fs18 box-center">
                <FaUser />
              </div>
              {(expanded || showSidebar) && (
                <div className="sidebar-content ml8 fs14 v-center jcsb sub-drop-icon flx1 ">
                  <p>My Account</p>
                  <RiArrowDropDownLine
                    className={`fs28 mr12 ${
                      isAccountDropdownOpen ? "rotate-icon" : ""
                    }`}
                  />
                </div>
              )}
            </div>
          </NavLink>
          {(expanded || showSidebar) && isAccountDropdownOpen && (
            <div className="sub-dropdown fs14 ls1 df fdc pb8 ml24">
              <NavLink to="/my-account?tab=settings">
                <div className="sub-item v-center">
                  <IoIosSettings className="fs16" />
                  <span className="ml8">Settings</span>
                </div>
              </NavLink>
              <NavLink to="/my-account?tab=course">
                <div className="sub-item v-center">
                  <FaBook className="fs16" />
                  <span className="ml8">Courses</span>
                </div>
              </NavLink>
              <NavLink to="/my-account?tab=documents">
                <div className="sub-item v-center">
                  <IoDocumentText className="fs16" />
                  <span className="ml8">Documents</span>
                </div>
              </NavLink>
              <NavLink to="/my-account?tab=billing">
                <div className="sub-item v-center">
                  <RiBillFill className="fs16" />
                  <span className="ml8">Billings</span>
                </div>
              </NavLink>
	            {user.access_by_login<=0 &&
              <NavLink to="/my-account?tab=Settings&section=newpass">
                <div className="sub-item v-center">
                  <RiBillFill className="fs16" />
                  <span className="ml8">Change Password</span>
                </div>
              </NavLink>
	    }
            </div>
          )}
	  <NavLink to="/calendar">
            <div
              className="sidebar-conatiner v-center"
            >
              <div className="icon-side fs18">
                <FaCalendarAlt />
              </div>
              {(expanded || showSidebar) && (
                <div className="sidebar-content ml8 fs14 v-center  jcsb sub-drop-icon flx1 ">
                  <p>My Calendar</p>
                </div>
              )}
            </div>
          </NavLink>
			  
	  {(user.access_by_login<=0) &&
          <NavLink to="/reviews">
            <div className="sidebar-conatiner v-center">
              <div className="icon-side fs18 v-center">
                <MdOutlineRateReview />
              </div>
              {(expanded || showSidebar) && (
                <div className="sidebar-content ml8 fs14">My Review</div>
              )}
            </div>
          </NavLink>
	   }
          {pageRoleAccess === "company" && pageOtherDataAccess != "free" ? 
            <NavLink to="/students">
              <div className="sidebar-conatiner v-center">
                <div className="icon-side fs18 v-center">
                  <IoIosPeople />
                </div>
                {(expanded || showSidebar) && (
                  <div className="sidebar-content ml8 fs14">My Teams</div>
                )}
              </div>
            </NavLink>
          : '' }
	  <NavLink to="/logs">
            <div className="sidebar-conatiner v-center">
              <div className="icon-side fs18 v-center">
                <GrCatalog />
              </div>
              {(expanded || showSidebar) && (
                <div className="sidebar-content ml8 fs14">Logs</div>
              )}
            </div>
          </NavLink>

        </div>
        <div className={`main-container`}>
          <main className="main-content">
            <Routes>
              <Route path="/my-account" element={<MyAccount />} />
              <Route path="/calendar" element={<Calendar />} />
	  {/* <Route path="/students" element={<Students />} />*/}
	      <Route path="/students" element={<MyStudent />} /> 
              <Route path="/reviews" element={<Review />} />
              <Route path="/logs" element={<MainLogs />} />
            </Routes>
          </main>
          {isContactPopupOpen && (
            <Popup onClose={closeContactRMPopup} title={"Support Request"}>
              <div className="contact-rm-form">
                <div className="form-group-settings issue w100 mb24">
                  <SingleDropdown
                    label="Select Issue Type"
                    options={issueOptions}
                    selectedOption={contactRMData.issueType}
                    onSelect={(option) =>
                      setContactRMData({ ...contactRMData, issueType: option })
                    }
                    bold={false}
                    required
                  />
                {errorMsg.issueType && <p className="error-message">{errorMsg.issueType}</p>}
                </div>
                <div className="form-group-settings desc-area w100 mt12">
                  <p className="fc15  fs14 ls1">
                    Describe your concern
                    <span className="fc5">*</span>
                  </p>
                  <textarea
                    id="comment"
                    placeholder={
                      contactRMData.issueType.description
                        ? contactRMData.issueType.description
                        : "Describe your concern"
                    }
                    autoComplete="off"
                    className="bg1 br4 mt8 fs14 w100 p16"
                    onChange={handleChange}
                    value={contactRMData.comment}
                  />
                    {errorMsg.comment && <p className="error-message">{errorMsg.comment}</p>}
                </div>
                <div className="button-container mt32 df jce">
                  <button
                    type="button"
                    className="btn-cancel"
                    onClick={closeContactRMPopup}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn-blue pl16 pr16 br24 ls1 "
		    onClick={handleSubmitRMContact}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Popup>
          )}
          {reminderPopup && (
            <AlertPopup onClose={closeReminderPopup}>
              <div className="alert-content v-center fdc">
                <div className="alert-img box-center bg6 br50 ">
                  <img src={Money} alt="Payment" />
                  {/* <img src={classImage} alt="Class" /> */}
                </div>
                <div className="alert-head box-center mt16 mb16 fs20 fc8 ls1 fw6 lh26 tac">
                  Payment Reminder
                </div>
                <div className="alert-desc fs16  lh18 ls1 fc6 tac">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s
                </div>
              </div>
              <div className="button-container mt24 pt24 df jcc">
                <button
                  type="button"
                  className="btn-cancel fs14 ls1"
                  onClick={closeReminderPopup}
                >
                  Skip
                </button>
                <button
                  type="button"
                  className="bg-orange pl16 pr16 br24 fc1 fs14 ls1 cp mr10"
                  onClick={closeReminderPopup}
                >
                  Later
                </button>

                <button
                  type="button"
                  className="btn-blue pl16 pr16 br24 fs14 ls1 "
                >
                  Pay Now
                </button>
              </div>
            </AlertPopup>
          )}
        </div>
      </div>
      <ScrollToTopButton show={showScrollToTop} />
      <ContactModal
	  otherDetailsUser={user.otherdata} 
	  constant={constant} 
	  user={user}
      />
    </>
  );
};

export default Layout;
